import React from 'react'
import format from 'format-number'
import ShareLink from 'react-twitter-share-link'
import totalCostsSum from '../../../../../../calculations/totalCosts/sum'
import { ReactComponent as TwitterIcon } from '../../../../../../assets/twitter.svg'
import Button from './Button'

const formatter = format({ prefix: '$', round: 0 })

const text = ({ form, url }) => `I just filled out @getplanswell’s Child Affordability Calculator and my personal total cost for raising a child is ${formatter(totalCostsSum(form))} - check it out for yourself at`

export default (props) => (
  <ShareLink link={props.url} text={text(props)}>
    {(href) => (
      <Button href={href} icon={TwitterIcon} />
    )}
  </ShareLink>
)
